export default __webpack_public_path__ + "static/media/cart-icon.338d051f.png";